export default __webpack_public_path__ + "static/media/weather_03.3aff29ca.png";